import React from 'react';

import Section from '../section';
import SummaryItem from '../summary-item';

const SectionExperience = ({ experience }) => {
  if (!experience.length) return null;
  return (
    <Section title="Experience">
      {experience.map((item) => (
        <SummaryItem
          key={item.name}
          name={item.name}
          title="Graduate Research Assistant,Machine Learning + Software Engineering, Feb 2020-Present"
          description={item.description}
          description_2="Wrote and maintained a custom Java GUI annotation application to annotate video frames
          received from the cameras. Used by a team of annotators in the Intelligent ICU Team. Written in
          Java, using JavaFX."
          description_3="Worked as a database administrator and was responsible for designing a MongoDB database
          schema for EHR(Electronic Health Record) data generated in the ICU. Wrote scripts in Python
          to automate transfer of data to the database, as well as generate weekly statistic reports for the
          database."
          link={item.link}
        />
      ))}
    </Section>
  );
};

export default SectionExperience;
